export default "__VITE_ASSET__B2NqjciK__"